// import { width } from '@mui/system';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import { BsPeople } from 'react-icons/bs';
import BottonMenu from "../uiComponents/BottonMenu";
import { BsWallet, BsGift } from 'react-icons/bs'
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { LanguageContext } from "./LanguageContext";
import { useContext } from "react";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { IoMenu } from "react-icons/io5";
import { ArrowRight } from "@mui/icons-material";

const w3_close = () => {
  const sidebar = document.getElementById("gold_sidebar");
  const overlay = document.getElementById("sidebarOverlay");

  if (sidebar) {
    sidebar.style.left = "-320px";
  }

  if (overlay) {
    overlay.style.display = "none";
  }
};

const w3_open = () => {
  const sidebar = document.getElementById("gold_sidebar");
  const overlay = document.getElementById("sidebarOverlay");

  if (sidebar) {
    sidebar.style.left = "0";
  }

  if (overlay) {
    overlay.style.display = "block";
  }
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);
const udata = localStorage.getItem("udata");
const profileData = JSON.parse(udata);

const Header = ({ user }) => {
  const location = useLocation();

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const respone = await apiRequest(`logout`, "POST", null, headers)

    localStorage.removeItem("token");
    window.location.reload();
    history.push("/");

  };

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false)


  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      console.log('beforeinstallprompt event was fired');
      setPromptInstall(e);
      setSupportsPWA(true)
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      console.log('No promptInstall event available');
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
      setPromptInstall(null);
    });
  };

  // language
  const { changeLanguage } = useContext(LanguageContext);
  const translations = {
    hi: {
      commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      // app: "ऐप डाउनलोड",
      kyc: "केवाईसी"
    },
    en: {
      commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      history: "History",
      support: "Support",
      notify: "Notification",
      // app: " App ",
      kyc: "KYC",
    },
  };

  const { language } = useContext(LanguageContext);

  // // change theme 
  // const { theme, toggleTheme } = useTheme("light");
  // const theme1 = localStorage.getItem('theme')

  // const styles = {
  //   backgroundColor: theme1 === 'light' ? '#000' : 'black',
  //   color: theme1 === 'light' ? '#fff' : '#fff',
  // };
  // const styles1 = {
  //   backgroundColor: theme1 === 'light' ? '#fff' : '#6c757d',
  //   color: theme1 === 'light' ? 'black !important' : '#fff !important',

  // };
  // const logo = theme1 === 'light' ? '../images/malik-ludo-logo1.png' : '../images/malik-ludo-logo1.png';

  // const colorChange = () => {
  //   localStorage.setItem("theme", "#fff")
  //   toggleTheme('#fff')
  // }

  // useEffect(() => {
  //   localStorage.setItem("theme", "light")

  // }, [])

  const { theme, toggleTheme } = useTheme();




  return (
    <>
      <div>
        {access_token ? (
          <React.Fragment>
            {/* <div id="sidebarOverlay" onClick={w3_close}></div> */}
            <div id="sidebarOverlay" className="gold_sidebar_overlay" onClick={w3_close}></div>

            <div className="tejal_sidebar_wrapper">

              <div
                className="tejal_sidebar"
                id="gold_sidebar"
              >

                {/* ================= CLOSE ================= */}

                <button
                  className="tejal_sidebar_close"
                  onClick={w3_close}
                >
                  ×
                </button>


                {/* ================= HEADER ================= */}

                <div className="tejal_sidebar_header">

                  <div className="tejal_sidebar_logo">
                    <img
                      src="../images/logo.png"
                      alt="Tejal Ludo"
                    />
                  </div>

                  {/* Premium Tagline */}
                  <div className="tejal_sidebar_tagline">

                    <span className="tejal_tagline_side"></span>

                    <div className="tejal_tagline_text">
                      <span className="tejal_tagline_dice">🎲</span>
                      <span>PLAY MORE</span>
                      <b>•</b>
                      <span>WIN MORE</span>
                      <b>•</b>
                      <span>EARN MORE</span>
                    </div>

                    <span className="tejal_tagline_side"></span>

                  </div>

                  <div className="tejal_sidebar_glow"></div>

                </div>



                {/* ================= MENU ================= */}

                <div className="tejal_sidebar_menu">


                  {/* PLAY */}

                  <Link
                    to="/Homepage/ludoClassicManual"
                    className="tejal_menu_item tejal_play_item"
                    onClick={w3_close}
                  >

                    <div className="tejal_menu_icon">
                      <img
                        src="./play-ludo.png"
                        alt="Play"
                      />
                    </div>

                    <div className="tejal_menu_text">
                      <h4>{translations[language].play}</h4>
                      <span>Start Playing</span>
                    </div>

                    <div className="tejal_menu_arrow">
                      <ArrowRight />
                    </div>

                  </Link>


                  {/* WALLET */}

                  <Link
                    to="/wallet"
                    className="tejal_menu_item"
                    onClick={w3_close}
                  >

                    <div className="tejal_menu_icon">
                      <img
                        src="./wallet-features.png"
                        alt="Wallet"
                      />
                    </div>

                    <div className="tejal_menu_text">
                      <h4>{translations[language].wallet}</h4>
                      <span>Manage your coins</span>
                    </div>

                    <div className="tejal_menu_arrow">
                      <ArrowRight />
                    </div>

                  </Link>


                  {/* REFER */}

                  {addCaseSetting?.isReferral && (
                    <Link
                      to="/refer"
                      className="tejal_menu_item"
                      onClick={w3_close}
                    >

                      <div className="tejal_menu_icon">
                        <img
                          src="./refer-features.png"
                          alt="Refer"
                        />
                      </div>

                      <div className="tejal_menu_text">
                        <h4>{translations[language].refer}</h4>
                        <span>Invite & Earn</span>
                      </div>

                      <div className="tejal_menu_arrow">
                        <ArrowRight />
                      </div>

                    </Link>
                  )}


                  {/* HISTORY */}

                  <Link
                    to="/history"
                    className="tejal_menu_item"
                    onClick={w3_close}
                  >

                    <div className="tejal_menu_icon">
                      <img
                        src="./history.png"
                        alt="History"
                      />
                    </div>

                    <div className="tejal_menu_text">
                      <h4>{translations[language].history}</h4>
                      <span>Game history</span>
                    </div>

                    <div className="tejal_menu_arrow">
                      <ArrowRight />
                    </div>

                  </Link>


                  {/* KYC */}

                  <Link
                    to="/Profile?kyc=true"
                    className="tejal_menu_item"
                    onClick={w3_close}
                  >

                    <div className="tejal_menu_icon">
                      <img
                        src="./kyc.png"
                        alt="KYC"
                      />
                    </div>

                    <div className="tejal_menu_text">
                      <h4>KYC Verification</h4>
                      <span>Verify your account</span>
                    </div>

                    <div className="tejal_menu_arrow">
                      <ArrowRight />
                    </div>

                  </Link>


                  {/* SUPPORT */}

                  <Link
                    to="/support"
                    className="tejal_menu_item"
                    onClick={w3_close}
                  >

                    <div className="tejal_menu_icon">
                      <img
                        src="./support-features.png"
                        alt="Support"
                      />
                    </div>

                    <div className="tejal_menu_text">
                      <h4>{translations[language].support}</h4>
                      <span>We're here to help</span>
                    </div>

                    <div className="tejal_menu_arrow">
                      <ArrowRight />
                    </div>

                  </Link>


                  {/* ================= THEME ================= */}

                  <div
                    className="tejal_menu_item tejal_theme_item"
                    onClick={toggleTheme}
                  >

                    <div className="tejal_menu_icon">

                      <img
                        src={
                          theme === "light"
                            ? "https://cdn-icons-png.flaticon.com/128/10976/10976127.png"
                            : "https://cdn-icons-png.flaticon.com/128/8484/8484254.png"
                        }
                        alt="theme"
                      />

                    </div>

                    <div className="tejal_menu_text">

                      <h4>
                        {theme === "light"
                          ? "Dark Mode"
                          : "Light Mode"}
                      </h4>

                      <span>
                        Change appearance
                      </span>

                    </div>

                    <div className="tejal_theme_toggle">
                      {theme === "light" ? "☾" : "☀"}
                    </div>

                  </div>


                  {/* ================= INSTALL APP ================= */}

                  {supportsPWA && (

                    <div
                      className="tejal_install_card"
                      onClick={onClick}
                    >

                      <div className="tejal_menu_icon">
                        <img
                          src="./install.png"
                          alt="Support"
                        />
                      </div>

                      <div className="tejal_install_content">

                        <h4>
                          Install App
                        </h4>

                        <p>
                          Fast access & better experience
                        </p>

                      </div>

                      <span>
                        <ArrowRight />
                      </span>

                    </div>

                  )}

                </div>




              </div>

            </div>


            <header className="rk_premium_header">

              {/* ================= HEADER LEFT ================= */}
              <div className="rk_header_left">

                {/* Hamburger */}
                <button
                  className="rk_menu_btn"
                  onClick={w3_open}
                  id="hambergar"
                  type="button"
                >
                  <span></span>
                  <span></span>
                  <span></span>

                  <div className="rk_menu_glow"></div>
                </button>


                {/* Logo */}
                <Link to="/" className="rk_header_logo_link">

                  <div className="rk_header_logo_wrap">

                    <img
                      src="../images/logo.png"
                      className="rk_header_logo"
                      alt="RK Ludo"
                    />

                  </div>

                </Link>

              </div>


              {/* ================= HEADER RIGHT ================= */}
              <div className="rk_header_right">


                {/* ================= COINS ================= */}
                <NavLink
                  exact
                  to="/Addcase"
                  className="rk_balance_card rk_coin_card"
                >

                  <div className="rk_balance_icon rk_coin_icon">

                    <img
                      src="../images/matka.png"
                      alt="Coins"
                    />

                    {/* <span className="rk_icon_spark"></span> */}

                  </div>


                  <div className="rk_balance_content">

                    <strong>
                      {user?.Wallet_balance || 0}
                    </strong>

                    <span>
                      COINS
                    </span>

                  </div>


                  {/* Plus */}
                  <div className="rk_balance_plus">
                    <FaPlus />
                  </div>

                </NavLink>



                {/* ================= REFERRAL ================= */}
                <NavLink
                  exact
                  to="/redeem/refer"
                  className="rk_balance_card rk_referral_card"
                >

                  <div className="rk_balance_icon rk_referral_icon">

                    <img
                      src="../images/coins.png"
                      alt="Referral"
                    />

                    {/* <span className="rk_icon_spark"></span> */}

                  </div>


                  <div className="rk_balance_content">

                    <strong>
                      {user?.referral_wallet?.toFixed(2) || "0.00"}
                    </strong>

                    <span>
                      REFERRAL
                    </span>

                  </div>


                  {/* Plus */}
                  {/* <div className="rk_balance_plus">
                    <FaPlus />
                  </div> */}

                </NavLink>

              </div>

            </header>
          </React.Fragment>
        ) : (
          <>
            {/* <div className="w3-teal " style={styles}>
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="./images/malik-logo.png"
                      className="snip-img"
                      alt="Malik "
                      width="30px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          </>
        )}
      </div>
      {location.pathname !== "/login" && (
        <div className="bottom_menus_main">
          <BottonMenu w3_close={w3_close} />
        </div>
      )}
    </>
  );
};

export default Header;
